const t = (o) => ({
  wrapper: {
    backgroundColor: o.palette.common.blue20
  },
  heading: {
    fontSize: "56px",
    color: o.palette.common.blue400,
    fontWeight: o.typography.fontWeightBold,
    lineHeight: 1.2,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize30
    }
  },
  subHeading: {
    color: o.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize14
    }
  },
  submitContent: {
    maxWidth: 630,
    margin: "0 auto",
    textAlign: "center"
  },
  submitTitle: {
    color: o.palette.common.blue400
  },
  submitDescription: {
    color: o.palette.common.blue400
  },
  moreRequestBtn: {
    maxWidth: 260
  }
}), e = t;
export {
  e as default
};
